var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseCircleFilled from '@material-ui/icons/Pause';
import './style.css';
import store from 'src/store';
import { updateUserAutoPlaySettingData } from 'src/auth/store/actions/user.actions';
import { mainApi } from 'src/config';
import { checkIfDevelopmentStage } from 'src/utils/common';
import { getTranslation } from 'src/translation';
var isDevStage = checkIfDevelopmentStage();
var mainApiUrl = mainApi(isDevStage);
var VideoSwitch = function (props) {
    var autoPlay = props.autoPlay, translate = props.translate;
    var handleAutoPlay = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios({
                        method: 'POST',
                        url: mainApiUrl.command + "/userCommand",
                        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                        data: {
                            type: 'updateAutoPlaySetting',
                            payload: {
                                autoPlay: !autoPlay,
                            },
                        },
                    })];
                case 1:
                    res = _a.sent();
                    if (!(res.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateUserAutoPlaySettingData({
                            isAutoPlay: !autoPlay,
                        })(store.dispatch)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "container-switch" },
        React.createElement("div", { className: "switch-container", onClick: function () { return handleAutoPlay(); }, title: String(translate(autoPlay ? 'autoplay-on' : 'autoplay-off')) },
            React.createElement("input", { type: "checkbox", id: "switch", checked: autoPlay }),
            React.createElement("label", { htmlFor: "switch" }, autoPlay ? (React.createElement(PlayArrowIcon, { style: {
                    color: 'black',
                    fontSize: '16px',
                    position: 'relative',
                } })) : (React.createElement(PauseCircleFilled, { style: {
                    color: 'black',
                    fontSize: '16px',
                    position: 'relative',
                } }))))));
};
var mapStateToProps = function (state) {
    var _a, _b, _c, _d;
    return {
        autoPlay: !!((_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.autoPlay),
        translate: getTranslation((_d = state === null || state === void 0 ? void 0 : state.translation) === null || _d === void 0 ? void 0 : _d.lang),
    };
};
export default connect(mapStateToProps)(VideoSwitch);



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/video/VideoSwitch.tsx
// module id = 1803
// module chunks = 81